"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.HeaderCloseButtonClickedAnalyticsEvent = exports.HeaderBackButtonClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when the user clicks the back button in the Navigation Header
 */
var HeaderBackButtonClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('header_back_button_clicked');
exports.HeaderBackButtonClickedAnalyticsEvent = HeaderBackButtonClickedAnalyticsEvent;
/**
 * Triggers when the user clicks the close button in the Navigation Header
 */
var HeaderCloseButtonClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('header_close_button_clicked');
exports.HeaderCloseButtonClickedAnalyticsEvent = HeaderCloseButtonClickedAnalyticsEvent;
